import PropTypes from 'prop-types';
import React, {PureComponent} from 'react';
import sAction from 'sAction';

import MoreOptions from 'ROOT/src/components/formElements/MoreOptions';
import CustomDetailViewTabContentRow from './CustomDetailViewTabContentRow';
import Button from 'ROOT/src/components/formElements/Button';

class CustomDetailTabContent extends PureComponent {
    addNewLine(e, key = null, module = null) {
        const way = this.props.way;
        sAction.addNewLineToTab(way, key, module);
    }

    addNewHeader(e, key = null, module = null) {
        const way = this.props.way;
        sAction.detailEditAddNewHeader(way, key, module);
    }

    onBtnClick(action, id, params) {
        sAction[action](id, params);
    }

    render() {
        const data = this.props.data;
        const module = this.props.module;
        const rowCount = this.props.rowCount;
        const id = this.props.id;
        const way = this.props.way;
        const fields = this.props.fields;
        const prefix = this.props.prefix;
        const index = this.props.index;
        const readonly = this.props.readonly;
        const mode = this.props.mode;

        const rows = [];
        data.rows.forEach((row, key) => {
            if (row.get('type') == 'headerPanel') {
                const headerName = row.get('name');
                const label = sAction.translate(headerName.toUpperCase(), module);
                rows.push(
                    <React.Fragment key={headerName}>
                        {mode == 'edit' && (
                            <div className="detailViewEditAddLineContainer">
                                <MoreOptions
                                    options={[
                                        {
                                            label: sAction.translate('LBL_ADD_NEW_LINE'),
                                            icon: 'icon-addIcon',
                                            value: 'addNewLine',
                                        },
                                        {
                                            label: sAction.translate('LBL_ADD_NEW_DETAIL_HEADER'),
                                            icon: 'icon-addIcon',
                                            value: 'addNewHeader',
                                        },
                                    ]}
                                    onClick={(e, val) => this[val](e, key, module)}
                                >
                                    <div className="icon-addIcon" />
                                </MoreOptions>
                            </div>
                        )}
                        <div className="detailViewPanelHeader">
                            <div className="detailViewPanelText" colSpan={2}>
                                {label}
                                {mode == 'edit' && (
                                    <>
                                        <div
                                            onClick={(e) =>
                                                sAction.editDetailEditTab(
                                                    e,
                                                    headerName.toUpperCase(),
                                                    module,
                                                    way + '/rows/' + key,
                                                )
                                            }
                                            className="icon-EditField detailViewEditTabButton"
                                            title={sAction.translate('LBL_EDIT_NAME')}
                                        ></div>
                                        <div
                                            onClick={(e) => sAction.dataDelete(way + '/rows', key)}
                                            className="icon-deleteIcon detailViewEditTabButton"
                                            title={sAction.translate('LBL_DELETE')}
                                        ></div>
                                    </>
                                )}
                            </div>
                        </div>
                    </React.Fragment>,
                );
            } else {
                rows.push(
                    <CustomDetailViewTabContentRow
                        prefix={prefix}
                        module={module}
                        way={way + '/rows/' + key}
                        key={key}
                        index={key}
                        data={row}
                        rowCount={100 / rowCount}
                        id={id}
                        fields={fields}
                        readonly={readonly}
                        acl={this.props.acl}
                        mode={mode}
                        attemptedSave={this.props.attemptedSave}
                    />,
                );
            }
        });

        const buttons = this.props?.buttons;

        const headerButtons = [];
        if (buttons.length > 0) {
            buttons.forEach((buttonRec, key) => {
                const button = buttonRec.toJS()?.def;
                if (!button) return;

                let buttonClass = 'customActionButton';
                if (button.extraClass != undefined) {
                    buttonClass += ' ' + button.extraClass;
                }

                headerButtons.push(
                    <Button
                        onClick={() => this.onBtnClick(button.onClick, button.id, button.params)}
                        className={buttonClass}
                        key={button.id}
                        id={button.id}
                        disabled={false}
                    >
                        {button.iconClass != undefined && (
                            <div
                                className={
                                    'actionPanelButtonIcon ' +
                                'icon-' +
                                button.iconClass
                                }
                                title={sAction.getStorage('debug') ? button.onClick : undefined}
                            />
                        )}
                        {sAction.translate(button.label, this.props.module)}
                    </Button>,
                );
            });
        }

        const isNewRecord = !this.props.id;
        const headerTitle = (
            <React.Fragment>
                <div className="header">
                    <div className="title">
                        <span className="detailViewName headerText">
                            {isNewRecord ? sAction.translate('LBL_NEW_RECORD') : sAction.decodeHTMLEntities(this.props.name)}
                        </span>
                    </div>

                    {headerButtons}
                </div>
            </React.Fragment>
        );

        let blok = '';
        if (data.active == true) {
            blok = (
                <div className="detailViewTabContentBlok select customDetailViewTabContent" data-index={index}>
                    {this.props.module === 'acm_portal_users' && headerTitle}
                    {rows}
                    {mode == 'edit' && (
                        <div className="detailViewEditAddLineContainer">
                            <MoreOptions
                                options={[
                                    {
                                        label: sAction.translate('LBL_ADD_NEW_LINE'),
                                        icon: 'icon-addIcon',
                                        value: 'addNewLine',
                                    },
                                    {
                                        label: sAction.translate('LBL_ADD_NEW_DETAIL_HEADER'),
                                        icon: 'icon-addIcon',
                                        value: 'addNewHeader',
                                    },
                                ]}
                                onClick={(e, val) => this[val](e, null, module)}
                            >
                                <div className="icon-addIcon" />
                            </MoreOptions>
                        </div>
                    )}
                </div>
            );
        } else {
            blok = (
                <div className="detailViewTabContentBlok customDetailViewTabContent" data-index={index}>
                    {rows}
                </div>
            );
        }

        return blok;
    }
}

CustomDetailTabContent.propTypes = {
    acl: PropTypes.any,
    attemptedSave: PropTypes.any,
    buttons: PropTypes.any,
    data: PropTypes.any,
    fields: PropTypes.any,
    id: PropTypes.any,
    index: PropTypes.any,
    mode: PropTypes.string,
    module: PropTypes.string,
    name: PropTypes.any,
    prefix: PropTypes.any,
    readonly: PropTypes.any,
    rowCount: PropTypes.any,
    way: PropTypes.string,
};

export default CustomDetailTabContent;
